import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as faRegStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { useUserStore } from "@/stores/userStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FavoritesButton',
    props: {
        query: null
    },
    emits: ["onFavorites"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faStar, faRegStar);
        const { isAnonymous } = storeToRefs(useUserStore());
        const FAVORITES = ["#favorites", "#favs", "#favourites"];
        const toggle = ref(false);
        const tooltipText = computed(() => {
            if (isAnonymous.value) {
                return "Log in to Favorite Tools";
            }
            else {
                if (toggle.value) {
                    return "Clear";
                }
                else {
                    return "Show favorites";
                }
            }
        });
        watch(() => props.query, () => {
            toggle.value = FAVORITES.includes(props.query);
        });
        function onFavorites() {
            toggle.value = !toggle.value;
            if (toggle.value) {
                emit("onFavorites", "#favorites");
            }
            else {
                emit("onFavorites", "");
            }
        }
        return { __sfc: true, props, emit, isAnonymous, FAVORITES, toggle, tooltipText, onFavorites, faStar, faRegStar, FontAwesomeIcon, BButton };
    }
});
